var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Sidan hittades inte")]),_c('p',[_c('a',{attrs:{"href":"/"}},[_vm._v("Gå till startsidan")])])])}]

export { render, staticRenderFns }